<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M4.3 17q.6 0 1 .3l1.4 1.4v.1a1 1 0 0 1-.3 1.7l-2.9 1.4a1 1 0 0 1-1.4-1.4l1.4-3h.1q.3-.4.7-.5"
    />
    <path
      fill-rule="evenodd"
      d="M21 2q1 .1 1 1v1a20 20 0 0 1-2.3 7.6 10 10 0 0 1-2 2.3v.9l-.3 1.9q-.1 1.1-.7 2.2t-1.9 1.7a16 16 0 0 1-4.5.8 1 1 0 0 1-1-.7l-.1-.1-.7-2.6-2.4-2.4-2.6-.7a1 1 0 0 1-.8-1v-.1l.1-1.4q.1-1.3.7-3.1.5-1.4 1.7-1.9t2.2-.7l2.7-.3h.1a10 10 0 0 1 2.3-2A17 17 0 0 1 21 2m-5.6 13.5-4.3 2.3-.3.2.2 1.1h.4l2.8-.6q.2 0 .6-.7l.5-1.6zm-6.9-7-.7.2-1.6.5-.7.6L5 13l1.1.2.2-.3zM15 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
      clip-rule="evenodd"
    />
  </svg>
</template>
